<div style="width: 26px;height: 26px">
  <mat-icon *ngIf="matIcon!=null" class="c-icon">{{matIcon}}</mat-icon>
  <img *ngIf="image!=null" class="c-icon" [src]="image">
  <div class="c-amount">{{amount}}</div>
</div>
